import { memo } from 'react'
import { Typography } from '@mui/material'
import styles from './SelectionRationale.module.css'

type SelectionRationaleProps = {
  selectionRationale?: string | null
}

export const SelectionRationale = memo(function SelectionRationale({
  selectionRationale,
}: SelectionRationaleProps) {
  if (!selectionRationale) return null

  return (
    <div className={styles.container}>
      <Typography variant='body2' color='text.secondary'>
        {selectionRationale}
      </Typography>
    </div>
  )
})
